<vo-shell-header [title]="routeTitle()" (toggleAppDrawer)="openDrawer()" />
<div class="relative flex grow flex-col overflow-hidden print:overflow-auto">
    <vo-alert-container />
    <vo-um-user-alert />
    <vo-notifications-sidebar />

    <vo-shell-nav-drawer [open]="navDrawerOpen()" (hideDrawer)="drawerHidden()" />
    <router-outlet />
</div>
